import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type UseSurveyBrandAccountQuery_MainQuery as Data } from '~/gql/graphql'
import { exists } from '~/utils'

import { useSurveyBrandAccountQueryKey } from './useSurveyBrandAccountQueryKey'

export const useSurveyBrandAccountQueryData = (
  surveyId: string | undefined,
) => {
  const queryKey = useSurveyBrandAccountQueryKey(surveyId)
  const { data } = useQuery<Data>({ enabled: false, queryKey })

  return React.useMemo(() => {
    const survey = data?.survey

    if (!exists(survey)) {
      return null
    }

    return survey
  }, [data?.survey])
}
